import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { memo, useRef, useState } from "react";

const TimInvestigasi = ({
  input,
  setInput,
  fetchNamaPegawai,
  loading,
  setSnackbar,
  readOnly = false,
}) => {
  const textInputRef = useRef(null);
  const [textInput, setTextInput] = useState({
    id: 0,
    email: "",
    idLapInvest: input.idLapInvest,
    userId: 0,
    nama: "",
    nopek: null,
    jabatanUser: null,
    jabatanTim: null,
  });

  const onSelect = (type, value) => {
    // value && fetchNamaPegawai(value, input.pelaksanaInvestigasi);
    switch (type) {
      case "namaPegawai":
        if (!value) {
          setInput((prev) => ({
            ...prev,
            listNamaPegawai: [],
          }));
          setTextInput((prev) => ({
            ...prev,
            nama: "",
            nopek: null,
            jabatanUser: null,
            email: "",
          }));
        } else if (value.userId) {
          setTextInput((prev) => ({
            ...prev,
            userId: value.userId,
            nama: value.namalengkap,
            nopek: value.nopek,
            jabatanUser: value.jabatan,
            email: value?.email,
          }));
        } else {
          setTextInput((prev) => ({
            ...prev,
            nama: value,
            userId: 0,
            nopek: null,
            jabatanUser: null,
            email: "",
          }));
        }
        break;
      case "jabatan":
        if (!value) {
          setTextInput((prev) => ({
            ...prev,
            jabatanTim: null,
          }));
        } else {
          setTextInput((prev) => ({ ...prev, jabatanTim: value }));
        }
        break;
    }
  };

  const onPressAddButton = () => {
    try {
      const newList = [...input.timInvestigasiList];
      if (!textInput.nama || !textInput.jabatanTim)
        throw "Pilih nama pegawai dan jabatan!";

      const isExists = newList.find((tim) => tim.nama == textInput.nama);
      if (isExists) throw "Nama ini sudah ada di dalam tim";

      newList.push(textInput);
      setInput((prev) => ({ ...prev, timInvestigasiList: newList }));
    } catch (error) {
      setSnackbar({
        isOpen: true,
        type: "error",
        message: error,
      });
    }
  };
  const onPressRemoveButton = (item) => {
    const newList = input.timInvestigasiList.filter((o) => o.nama != item.nama);
    setInput((prev) => ({ ...prev, timInvestigasiList: newList }));
  };

  if (loading) {
    return (
      <Box sx={styles.container}>
        <h3 style={{ textAlign: "center", fontWeight: "bold" }}>
          Tim Investigasi
        </h3>
        <Grid container rowGap={1} columnGap={1}>
          <Grid item xl={4} lg={5} sm={12} xs={12}>
            <FormControl fullWidth>
              <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
            </FormControl>
          </Grid>
          <Grid item xl={4} lg={5} sm={12} xs={12}>
            <FormControl fullWidth>
              <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
            </FormControl>
          </Grid>
        </Grid>
        <TableContainer>
          <Table>
            <TableHead sx={{ width: "100%" }}>
              <TableRow>
                <TableCell>
                  <h4>Nama Pegawai</h4>
                </TableCell>
                <TableCell>
                  <h4>No. Pegawai</h4>
                </TableCell>
                <TableCell>
                  <h4>Jabatan</h4>
                </TableCell>
                <TableCell>
                  <h4>Jabatan Tim Investigasi</h4>
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                </TableCell>
                <TableCell>
                  <Skeleton variant="text" sx={{ fontSize: "2.5rem" }} />
                </TableCell>
                <TableCell>
                  <IconButton color="primary" component="label">
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  return (
    <>
      <Box sx={styles.container}>
        <h3 style={{ textAlign: "center", fontWeight: "bold" }}>
          Tim Investigasi
        </h3>
        <Grid container rowGap={1} columnGap={1}>
          <Grid item xl={4} lg={5} sm={12} xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                options={input.listNamaPegawai}
                getOptionLabel={(option) => option.namalengkap}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    ref={textInputRef}
                    label="Ketik Nama Pegawai"
                  />
                )}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.defaultPrevented = true;
                    fetchNamaPegawai(
                      e.target.value,
                      input.pelaksanaInvestigasi
                    );
                  }
                }}
                onChange={(e, value) => onSelect("namaPegawai", value)}
                disabled={readOnly}
              />
            </FormControl>
          </Grid>
          <Grid item xl={4} lg={5} sm={12} xs={12}>
            <FormControl fullWidth>
              <Autocomplete
                options={input.listJabatan}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    ref={textInputRef}
                    label="Pilih Jabatan Tim Investigasi"
                  />
                )}
                onChange={(e, value) => onSelect("jabatan", value)}
                disabled={readOnly}
              />
            </FormControl>
          </Grid>
          <Grid item xl={3} lg={1} sm={3} xs={12}>
            <Button
              variant="contained"
              sx={{ fontSize: "1.5rem", height: "100%" }}
              onClick={() => onPressAddButton()}
              disabled={readOnly}
            >
              +
            </Button>
          </Grid>
        </Grid>
        <TableContainer>
          <Table>
            <TableHead sx={{ width: "100%" }}>
              <TableRow>
                <TableCell>
                  <h4>Nama Pegawai</h4>
                </TableCell>
                <TableCell>
                  <h4>No. Pegawai</h4>
                </TableCell>
                <TableCell>
                  <h4>Jabatan</h4>
                </TableCell>
                <TableCell>
                  <h4>Jabatan Tim Investigasi</h4>
                </TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {input.timInvestigasiList.map((item, idx) => (
                <TableRow key={idx}>
                  <TableCell>{item.nama}</TableCell>
                  <TableCell>{item.nopek || "-"}</TableCell>
                  <TableCell>{item.jabatanUser || "-"}</TableCell>
                  <TableCell>{item.jabatanTim}</TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      component="label"
                      onClick={() => onPressRemoveButton(item)}
                      disabled={readOnly}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

const styles = {
  container: {
    px: 5,
    mt: 3,
    pt: 1,
    pb: 5,
    borderRadius: 3,
    display: "block",
    backgroundColor: "#fff",
  },
  field: {
    border: 1,
    borderColor: "lightgrey",
    px: 3,
    py: 2,
    borderRadius: 3,
    display: "block",
    backgroundColor: "#fff",
  },
};
export default memo(TimInvestigasi);
